import EnumDataSource from "../utils/enum-data-source.util";

export const APPOINTMENT_OUTCOME_REASON_CONVERTED = 1;
export const APPOINTMENT_OUTCOME_REASON_NOT_CONVERTED = 2;
export const APPOINTMENT_OUTCOME_REASON_EXCLUDED = 3;
// OPEN = opportunity happened but is still undecided (in demo, awaiting decision).
// Excluded from the close-rate denominator on the backend, like EXCLUDED.
export const APPOINTMENT_OUTCOME_REASON_OPEN = 7;

const appointmentOutcomeReasonTypes = {
  [APPOINTMENT_OUTCOME_REASON_CONVERTED]: "Converted",
  [APPOINTMENT_OUTCOME_REASON_NOT_CONVERTED]: "Not Converted",
  [APPOINTMENT_OUTCOME_REASON_EXCLUDED]: "Excluded",
  [APPOINTMENT_OUTCOME_REASON_OPEN]: "Open",
};

// Explicit display order: Open (7) sits right below Excluded, not after the
// cancellation outcomes (4-6). Numeric object keys would otherwise sort ascending.
const appointmentOutcomeReasonTypesOrder = {
  [APPOINTMENT_OUTCOME_REASON_CONVERTED]: 1,
  [APPOINTMENT_OUTCOME_REASON_NOT_CONVERTED]: 2,
  [APPOINTMENT_OUTCOME_REASON_EXCLUDED]: 3,
  [APPOINTMENT_OUTCOME_REASON_OPEN]: 4,
};

export const APPOINTMENT_OUTCOME_REASON_TYPES = new EnumDataSource(
  appointmentOutcomeReasonTypes,
  appointmentOutcomeReasonTypesOrder
);

export const APPOINTMENT_OUTCOME_REASON_RESCHEDULED = 4;
export const APPOINTMENT_OUTCOME_REASON_DECLINED = 5;
export const APPOINTMENT_OUTCOME_REASON_NO_ANSWER = 6;

const appointmentCancellationOutcomeReasonTypes = {
  [APPOINTMENT_OUTCOME_REASON_RESCHEDULED]: "Rescheduled",
  [APPOINTMENT_OUTCOME_REASON_DECLINED]: "Declined",
  [APPOINTMENT_OUTCOME_REASON_NO_ANSWER]: "No Answer",
};

export const APPOINTMENT_CANCELLATION_OUTCOME_REASON_TYPES = new EnumDataSource(
  appointmentCancellationOutcomeReasonTypes
);

export const APPOINTMENT_OUTCOME_REASON_ALL_TYPES = new EnumDataSource(
  {
    ...appointmentOutcomeReasonTypes,
    ...appointmentCancellationOutcomeReasonTypes,
  },
  {
    ...appointmentOutcomeReasonTypesOrder,
    [APPOINTMENT_OUTCOME_REASON_RESCHEDULED]: 5,
    [APPOINTMENT_OUTCOME_REASON_DECLINED]: 6,
    [APPOINTMENT_OUTCOME_REASON_NO_ANSWER]: 7,
  }
);
